import React from 'react';

import classes from './CommonTag.scss';

const commonTag = (props) => (
    <div className={`${classes.Tag} u-flex justify-content-center align-items-center u-textAlignCenter u-textColorWhite u-backgroundColorPrimary u-textUppercase u-borderRadius4 u-fontSize11 u-lineHeight1`}>{props.children}</div>
);

export default commonTag;


// WEBPACK FOOTER //
// ./src/components/Payment/Common/CommonTag/CommonTag.js